import Table from '@alliancesafetycouncil/asc-table';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getGatesByNetwork } from '../../../actions/Gates/Gates';

class GatesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnDefs: [
        { headerName: 'Gate Name', field: 'name', cellRenderer: 'renderName' },
        { headerName: 'Parent Site', field: 'site' },
        { headerName: 'Parent Company', field: 'company' },
        { headerName: 'Contact Name', field: 'contact' },
        { headerName: 'Contact Phone', field: 'phone' },
        { headerName: 'Notes', field: 'notes' },
        {
          headerName: 'Status',
          field: 'status',
          filter: 'agSetColumnFilter',
          valueFormatter: (params) => params.value.charAt(0).toUpperCase() + params.value.slice(1, params.value.length),
        },
      ],
      customCells: {
        renderName: (row) => {
          return (
            row.data && (
              <Link to={`/gates/gate-details/${row.data.id}/${props.details.network.id}/details`}>{row.data.name}</Link>
            )
          );
        },
      },
      config: [
        {
          type: 'primary',
          size: 'md',
          label: 'Add Gate',
          href: `/#/gates/add-gate/${this.props.match.params.networkId}`,
        },
      ],
    };
  }

  componentWillMount() {
    this.props.GetGatesByNetwork(this.props.match.params.networkId);
  }

  render() {
    const { data } = this.props;
    const networkId = this.props.match.params.networkId;

    return (
      <Table
        {...this.props}
        className="ag-theme-balham flex flex-1 flex-col relative text-sm"
        columnDefs={this.state.columnDefs}
        getData={() => this.props.GetGatesByNetwork(networkId)}
        customCells={this.state.customCells}
        data={data}
        headerConfig={this.state.config}
        customCells={this.state.customCells}
        defaultColDef={this.state.defaultColDef}
        filter_type="any"
        getGridApi={this.getGridApi}
        enablePagination={false}
        defaultFilter={{ column: 'status', value: 'active' }}
        rowHeight={50}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    busy: state.gateService.busy,
    res: state.gateService.res,
    err: state.gateService.err,
    data: state.gateService.data,
    details: state.companyService.details,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetGatesByNetwork: (networkId) => dispatch(getGatesByNetwork(networkId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GatesTab);
